import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import React, { useState } from "react";
import styles from "./style.module.css";
import CreditCardImage from "../../../CreditCardImage";
import PaymentMenu from "../PaymentMenu";
import * as PropTypes from "prop-types";
import { ReactComponent as DotIcon } from "./image/ic-more.svg";
import { ReactComponent as CurrentIcon } from "./image/ic_selected.svg";
import Button from "@material-ui/core/Button";
import classnames from "classnames";

const PaymentItem = React.memo(({ token, bankCardType, name, deletePaymentMethod, selectPayment, currentPayment }) => {
  const [ anchorEl, setAnchorEl ] = useState(null);
  const [ open, setToggle ] = useState(false);
  const [ isConfirmationModalOpen, setIsConfirmationModalOpen ] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setToggle(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setToggle(false);
  };

  const handleDelete = (token) => {
    setToggle(false);
    setIsConfirmationModalOpen(true);
  };

  const closeModal = () => {
    setIsConfirmationModalOpen(false);
  };
  const handleSubmit = () => {
    deletePaymentMethod(token);
    closeModal();
  };

  return (
    <>
      <div key={token} className={styles.paymentItem}>
        <div
          className={styles.paymentContainer}
          onClick={() => selectPayment(token)}
        >
          <div className={styles.paymentCurrentIcon}>
            {currentPayment &&
            <CurrentIcon />}
          </div>
          <div className={styles.paymentImage}>
            <CreditCardImage cardType={bankCardType} />
          </div>
          <div className={styles.paymentCarNumber}>
            {name}
          </div>
          <div className={styles.paymentName}>
            {bankCardType}
          </div>
        </div>
        <Button
          className={classnames({
            [styles.paymentButton]: true,
            [styles.hover]: open,
          })}
          onClick={(event) => handleClick(event)}
        >
          <DotIcon />
        </Button>
      </div>
      <Dialog PaperProps={{ className: styles.container }} open={isConfirmationModalOpen} onClose={closeModal}>
        <DialogTitle id="form-dialog-title">
          <div className={styles.formTitle}>
            You are going to remove this payment method:
          </div>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <div className={styles.paymentImage}>
            <CreditCardImage cardType={bankCardType} />
          </div>
          <div className={styles.paymentCarNumber}>
            {name}
          </div>
          <div className={styles.paymentName}>
            {bankCardType}
          </div>
        </DialogContent>
        <DialogActions>
          <div className={styles.formButtonBlock}>
            <Button type='button'
                    variant='contained'
                    className={styles.formButtonCancel}
                    onClick={closeModal}
            >
              Cancel
            </Button>
            <Button type='submit'
                    variant='contained'
                    className={styles.formButtonSave}
                    onClick={handleSubmit}
            >
              Confirm
            </Button>
          </div>
        </DialogActions>
      </Dialog>
      <PaymentMenu
        id={token}
        anchorEl={anchorEl}
        open={open}
        handleClose={handleClose}
        handleDelete={handleDelete}
      />
    </>
  );
});

PaymentItem.propTypes = {
  token: PropTypes.string.isRequired,
  bankCardType: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  deletePaymentMethod: PropTypes.func.isRequired,
  selectPayment: PropTypes.func.isRequired,
  currentPayment: PropTypes.bool.isRequired,
};

export default PaymentItem;
